/**
 * Device Storage API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Version } from './version';


export interface FirmwareVersionDto { 
    addedDeviceFeatures?: Array<FirmwareVersionDto.AddedDeviceFeaturesEnum>;
    binaryChecksum?: string;
    binarySize?: number;
    binaryUploadDate?: string;
    creationDate?: string;
    firmwareClassId?: string;
    id?: string;
    officialChangelog?: string;
    otherChanges?: string;
    releaseDate?: string;
    releaseDescription?: string;
    releaseForCustomer?: boolean;
    removedDeviceFeatures?: Array<FirmwareVersionDto.RemovedDeviceFeaturesEnum>;
    version?: Version;
}
export namespace FirmwareVersionDto {
    export const AddedDeviceFeaturesEnum = {
        RemoteCommandSetLongParameter: 'REMOTE_COMMAND_SET_LONG_PARAMETER',
        OnlyPositionShortHeaderMessageFormat: 'ONLY_POSITION_SHORT_HEADER_MESSAGE_FORMAT',
        ShortHeaderMessageFormat: 'SHORT_HEADER_MESSAGE_FORMAT',
        LegacyMessageFormat: 'LEGACY_MESSAGE_FORMAT',
        HighActivityCameraTrigger: 'HIGH_ACTIVITY_CAMERA_TRIGGER',
        BrokenSchedulePeriodLength: 'BROKEN_SCHEDULE_PERIOD_LENGTH',
        BrokenUserParameterViaRemoteCommand: 'BROKEN_USER_PARAMETER_VIA_REMOTE_COMMAND'
    } as const;
    export type AddedDeviceFeaturesEnum = typeof AddedDeviceFeaturesEnum[keyof typeof AddedDeviceFeaturesEnum];
    export const RemovedDeviceFeaturesEnum = {
        RemoteCommandSetLongParameter: 'REMOTE_COMMAND_SET_LONG_PARAMETER',
        OnlyPositionShortHeaderMessageFormat: 'ONLY_POSITION_SHORT_HEADER_MESSAGE_FORMAT',
        ShortHeaderMessageFormat: 'SHORT_HEADER_MESSAGE_FORMAT',
        LegacyMessageFormat: 'LEGACY_MESSAGE_FORMAT',
        HighActivityCameraTrigger: 'HIGH_ACTIVITY_CAMERA_TRIGGER',
        BrokenSchedulePeriodLength: 'BROKEN_SCHEDULE_PERIOD_LENGTH',
        BrokenUserParameterViaRemoteCommand: 'BROKEN_USER_PARAMETER_VIA_REMOTE_COMMAND'
    } as const;
    export type RemovedDeviceFeaturesEnum = typeof RemovedDeviceFeaturesEnum[keyof typeof RemovedDeviceFeaturesEnum];
}


